import React from 'react';
import PropTypes from 'prop-types';

import ResponsiveModalShell from '../ResponsiveModalShell';
import SelectionFooter from '../SelectionFooter';
import {useSourceSelection, useItemSelection} from '../useSourceSelection';

/**
 * Portfolio-like sources (Musterdepots, Modellportfolios, Vermögensverwaltung).
 *
 * Two mutually exclusive modes:
 *  - LIST:   multi-select whole items from the list.
 *  - DETAIL: drill into a single item to select its instruments and/or the whole item.
 */
function PortfolioSelectionFlow({open, onClose, onSelectProducts, SourceComponent, backToSourceLabel}) {
  const items = useItemSelection();
  const selection = useSourceSelection({items, open, onClose, onSelectProducts});

  return (
    <ResponsiveModalShell
      open={open}
      onClose={onClose}
      footer={
        <SelectionFooter
          onBack={selection.goBack}
          onConfirm={selection.confirm}
          confirmDisabled={!selection.hasSelection}
          inDetail={selection.inDetail}
          withItemSelection
          backToSourceLabel={backToSourceLabel}
        />
      }
    >
      <SourceComponent
        onDetailsClick={selection.drillInto}
        selectedItem={selection.activeItem}
        onInstrumentSelect={selection.toggleInstrument}
        onSelectAll={selection.selectAllInstruments}
        selectedInstruments={selection.selectedInstruments}
        onSourceSelect={selection.toggleSourceSelected}
        sourceSelected={selection.isSourceSelected}
        onListItemSelect={selection.toggleItem}
        isItemSelected={selection.isItemSelected}
        forceAllAssetsSelection={false}
        directAddingPossible={false}
      />
    </ResponsiveModalShell>
  );
}

PortfolioSelectionFlow.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSelectProducts: PropTypes.func.isRequired,
  SourceComponent: PropTypes.elementType.isRequired,
  backToSourceLabel: PropTypes.string,
};

export default PortfolioSelectionFlow;
